export default __webpack_public_path__ + "static/media/270deg.e64feecd.svg";